module.exports = __webpack_public_path__ + "static/media/shrimp.07370908.svg";